import { render, staticRenderFns } from "./dealHistory.vue?vue&type=template&id=edb701fe&scoped=true"
import script from "./dealHistory.vue?vue&type=script&lang=js"
export * from "./dealHistory.vue?vue&type=script&lang=js"
import style0 from "./dealHistory.vue?vue&type=style&index=0&id=edb701fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb701fe",
  null
  
)

export default component.exports